var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconLoaded)?_c('b-icon',_vm._b({attrs:{"icon":_vm.icon}},'b-icon',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }